export default class EventHandler {
  observers = {};
  dispatchHistory = false;
  history = {};

  subscribe(eventName, cb, withHistory = false) {
    if (typeof cb !== 'function') {
      return
    };
    this.observers[eventName] = this.observers[eventName] ? this.observers[eventName] : [];    
    this.observers[eventName].push(cb);
    if ((this.dispatchHistory || withHistory) && this.history[eventName]) {
      cb(this.history[eventName]);
    }
  }

  unsubscribe(eventName, context) {
    if (!this.observers[eventName]) {
      return
    };
    for (let i = this.observers[eventName].length - 1; i >= 0; --i) {
      if (this.observers[eventName][i] === context) {
        this.observers[eventName].splice(i, 1);
        return;
      }
    }
  }

  dispatch(eventName, value, withHistory = false) {
    if (this.dispatchHistory || withHistory) {
      this.history[eventName] = value;
    }

    if (!this.observers[eventName]) {
      return
    };
    for (let i = 0; i < this.observers[eventName].length; i++) {
      this.observers[eventName][i](value);
    }
  }
}
